import axios from "axios";

export function HandleException(exception, setErrorMessage) {
    if(axios.isAxiosError(exception) && setErrorMessage != null) {

        const data = extractException(exception);

        setErrorMessage(data.message)
        if(data.redirected && window.location.pathname !== data.redirectPath) {
            const prevPath = window.location.pathname;
            window.location.href = data.redirectPath + "?redirect=" + prevPath;

        }
        return true;


    }
    return false;
}

export function extractException(axiosResponse) {
    if(axiosResponse.response != null && axiosResponse.response.data != null) {
        return axiosResponse.response.data;
    }
    return null;
}